import { forwardRef } from "react";

import { NumberField as BaseNumberField } from "@base-ui/react/number-field";

import { cn } from "..";
import { controlInputVariants } from "../Control/control.variant";

const NumberFieldInput = forwardRef<HTMLInputElement, React.ComponentPropsWithRef<typeof BaseNumberField.Input>>(
  (props, forwardedRef) => {
    const { className, ...inputProps } = props;

    return (
      <BaseNumberField.Input
        {...inputProps}
        ref={forwardedRef}
        className={cn(
          controlInputVariants(),
          "px-3 py-2.5 flex-1 border-none bg-transparent outline-none",
          "text-center [font-variant-numeric:tabular-nums]",
          "[&::-webkit-outer-spin-button]:m-0 [&::-webkit-outer-spin-button]:appearance-none",
          "[&::-webkit-inner-spin-button]:m-0 [&::-webkit-inner-spin-button]:appearance-none",
          "[&[type=number]]:[appearance:textfield] [&[type=number]]:[-moz-appearance:textfield]",
          className,
        )}
      />
    );
  },
);

NumberFieldInput.displayName = "NumberField.Input";

export default NumberFieldInput;
